import type {NavigationGuardReturn, RouteLocationNormalized} from 'vue-router';
import {useFeatureFlagStore} from '../../stores/featureFlagStore';

export async function beforeEnterUserAdministration(
    to: RouteLocationNormalized
): Promise<NavigationGuardReturn> {
    const featureEnabled = await useFeatureFlagStore().newUserAdministration.isReady();

    // Only redirect AdminUserList to AdminUserListNew when feature is enabled
    if (featureEnabled && to.name === 'AdminUserList') {
        return {name: 'AdminUserListNew', params: to.params};
    }

    // Allow all other routes (AdminUserAdd, AdminUserEdit, etc.) to proceed normally
}
